// Function used to swap the images in the header.
// Used by everypage
var isMac = (navigator.appVersion.indexOf("Mac")!=-1) ? true : false;
var isNS4 = (document.layers) ? true : false;
var isIEmac = ((document.all)&&(isMac)) ? true : false;
var isIE4plus = (document.all) ? true : false;
var isIE4 = ((document.all)&&(navigator.appVersion.indexOf("MSIE 4.")!=-1)) ? true : false;
var isIE5 = ((document.all)&&(navigator.appVersion.indexOf("MSIE 5.")!=-1)) ? true : false;
var isIE6 = ((document.all)&&(navigator.appVersion.indexOf("MSIE 6.")!=-1)) ? true : false;
var isIE7 = ((document.all)&&(navigator.appVersion.indexOf("MSIE 7.")!=-1)) ? true : false;
var isNS6 = ((!document.layers)&&(navigator.userAgent.indexOf('Netscape')!=-1)) ? true : false;
var isVer6 = (isIE6) || (isNS6);
var isIE = ((document.all)&&(navigator.userAgent.indexOf('MSIE') != -1));
var isNS = (isNS4) || (isNS6);
var isGecko = (navigator.userAgent.indexOf('Gecko') != -1);
var isMozilla = ((isGecko)&&(!isNS)&&(!isIE)&&(navigator.userAgent.indexOf('Mozilla')!=-1));
var isOpera = (navigator.userAgent.indexOf('Opera')!=-1);
var isDOM = (((isIE)&&(!isIE4)) || (isNS6) || (isMozilla) || (isOpera));
var isIE5up = ((isIE4plus)&&(!isIE4));
var isIE6up = ((isIE4plus) && (!isIE4) && (!isIE5));

//function that is more comprehensive than the above trash.
function get_browser_info() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return { name: 'Opera', version: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
        name: M[0],
        version: M[1]
    };
}

function changeImages(img, newimg) {
	if (document.images) {
		document.images[img].src = eval(newimg + ".src");
	}
}

function openWin(winName, loc, width, height) {					// Opens a new window
	var newWindow;
	newWindow = window.open(loc, winName, "location=no,status=no,scrollbars=no,toolbar=no,menubar=no,directories=no,resizable=no,width="+width+",height="+height);
	newWindow.focus();
}

function openWinFull(loc) {					// Opens a new window
	var newWindow;
	newWindow = window.open(loc);
	newWindow.focus();
}

function openWinScroll(winName, loc, width, height) {					// Opens a new window
	var newWindow;
	newWindow = window.open(loc, winName, "location=no,status=yes,scrollbars=yes,toolbar=no,menubar=no,directories=no,resizable=yes,width="+width+",height="+height);
	newWindow.focus();
}

function openWinPrintable(winName, loc, width, height) {
	var newWindow;
	newWindow = window.open(loc, winName, "location=yes,status=yes,scrollbars=yes,toolbar=yes,menubar=yes,directories=no,resizable=yes,width="+width+",height="+height);
	newWindow.focus();
}

// Cross browser object finder
function getElement(id) {
	if (document.all) {
		return document.all(id);
	} else if (document.getElementById) {
		return document.getElementById(id);		//works IE5+ and NS6+
	} else {
		return findLayer(id, document);
	}
}

function changecursor(obj, icon) {
	switch (icon) {
		case 'hand':	/* Fall through to the next one */
		case 'pointer':
			obj.style.cursor = (isIE && !isIE6up) ? 'hand' : 'pointer';
			break;
		case 'auto':
			obj.style.cursor = 'default';
			break;
		default:
			obj.style.cursor = icon;
			break;
	}
}

function findLayer(name, doc) {
	var i, layer;

	for (i = 0; i < doc.layers.length; i++) {
		layer = doc.layers[i];

		if (layer.name == name) {
			return layer;

			if (layer.document.layers.length > 0)
				layer = findLayer(name, layer.document);

			if (layer != null)
				return layer;
		}
	}
	return null;
}

// Matches any integer only
function isValidInteger(test) {
	test = test.toString();
	if (isNaN(parseInt(test,10))) {
		return false;
	}
	else {
		// Trim the string
		test=test.replace(/^\s+/g, '');
		test=test.replace(/\s+$/g,'');

		var result = test.match(/^[-+]?\d+$/g);
		if (result == null) {
			return false;
		}
		else if (result[0] == test) {
			return true;
		}
		else {
			return false;
		}
	}
}
// Matches any positive integer only
function isValidPositiveInteger(test) {
	test = test.toString();
	if (isNaN(parseInt(test,10))  || parseInt(test, 10) == 0) {
		return false;
	}
	else {
		// Trim the string
		test=test.replace(/^\s+/g, '');
		test=test.replace(/\s+$/g,'');

		var result = test.match(/^\d+$/g);
		if (result == null) {
			return false;
		}
		else if (result[0] == test) {
			return true;
		}
		else {
			return false;
		}
	}
}


// Matches positive (> 0) floating point numbers only
function isValidDecimal(test) {
	test = test.toString();
	if (isNaN(parseFloat(test)) || parseFloat(test) == 0) {
		return false;
	}
	else {
		// Trim the string (left and right)
		test=test.replace(/^\s+/g,'');
		test=test.replace(/\s+$/g,'');

		var result = test.match(/^(\d+\.?\d*)|(\d*\.?\d+)$/);
		if (result == null) {
			return false;
		}
		else if (result[0] == test) {
			if (parseFloat(test) == 0)
				return false;
			else
				return true;
		}
		else {
			return false;
		}
	}
}
function isValidPositiveDecimal(test) {
	test = test.toString();
	if (isNaN(parseFloat(test)) || parseFloat(test) == 0) {
		return false;
	}
	else {
		// Trim the string
		test=test.replace(/^\s+/g, '');
		test=test.replace(/\s+$/g,'');

		var result = test.match(/^[-+]?(\d+\.?\d*)|(\d*\.?\d+)$/);
		if (result == null) {
			return false;
		}
		else if (result[0] == test) {
			if (parseFloat(test) == 0)
				return false;
			else
				return true;
		}
		else {
			return false;
		}
	}
}


function formatdecimal(num) {
	var left, right, str;
	var tmp1 = '';
	var tmp2 = '';
	var commas = 0;

	str = Math.round(num * 100).toString();
	left = str.substring(0, str.length - 2);
	right = str.substring(str.length - 2, str.length);

	commas = parseInt((left.length / 3).toString(),10);
	tmp1 = left;
	for (var i=0;i<commas;i++) {
		tmp2 = ((tmp1.length!= 3) ? ',' : '') + tmp1.substring(tmp1.length - 3, tmp1.length) + tmp2;
		tmp1 = tmp1.substring(0, tmp1.length - 3);
	}

	left = tmp1 + tmp2;

	if (left.length == 0)
		left = '0';		// Make sure we have a leading zero
	if (right.length < 1)
		right = '00';
	else if(right.length < 2)
		right = '0' + right;

	return left + '.' + right;
}

/* function formatcurrency(num, showIfZero) {
	var left, right, str;
	var tmp1 = '';
	var tmp2 = '';
	var commas = 0;
    var priceString = '';

	str = Math.round(num * 100).toString();
	left = str.substring(0, str.length - 2);

	// Put commas after every 3rd number
	commas = parseInt((left.length / 3).toString(),10);
	tmp1 = left;
	for (var i=0;i<commas;i++) {
		tmp2 = ((tmp1.length!= 3) ? ',' : '') + tmp1.substring(tmp1.length - 3, tmp1.length) + tmp2;
		tmp1 = tmp1.substring(0, tmp1.length - 3);
	}

	left = tmp1 + tmp2;
	right = str.substring(str.length - 2, str.length);

	if (left.length == 0)
		left = '0';		// Make sure we have a leading zero
	if (right.length < 1)
		right = '00';
	else if(right.length < 2)
		right = '0' + right;

	priceString = '$' + left + '.' + right;

    if (priceString == '$0.00' && (showIfZero == undefined || !showIfZero))
        return '';

    return priceString;
} */

function InchesToMillimeters(value) {
	return value * 25.4;
}

function MillimetersToInches(value) {
	return value / 25.4;
}


function roundup(value, decimals) {
	var tmp;

	tmp = parseFloat(value);
	if (isNaN(tmp)) {
		return tmp;
	}

	tmp = Math.ceil(tmp * Math.pow(10, decimals)).toString();
	tmp = tmp / Math.pow(10, decimals);
	return tmp;
}

function closeWindow() {
if(window.opener != null) {
var p = window.opener;
p.focus();
}
window.close();
}

function closeAndChangeParent(id, url) {
if(window.opener != null) {
var p = window.opener;
window.opener.location = url;
getElement(id).style.cursor = 'wait';
setTimeout('closeWindow()', 1000)
} else {
window.location = url;
}
}

function URLencode(sStr) {
return escape(sStr).replace(/\+/g, '%2C').replace(/\"/g,'%22').replace(/\'/g, '%27');
}

function OpenerURL() {
//Returns the RELATIVE URL
if (window.opener != null) {
return window.opener.location.pathname + window.opener.location.search;
} else {
return window.location.pathname + window.location.search;
}
}

// USE: <textarea id="instructions" cols="1" rows="2" onkeypress="return maxWidth(this, event, 200)">
function maxWidth(obj, e, maxlength) {
var code;
if (window.event) code = window.event.keyCode;
else if (e)	code = e.which;
else code = null;

// Certain control keys like delete and backspace should always be allowed
if ( code==null || code==0 || code==8 || code==9 || code==13 || code==27 ) return true;

if (obj.value.length < maxlength) return true;
else return false;
}

function trim(str) {
if(!str) {
return str;
} else {
var test = str.replace(/^\s+/g, '');
test=test.replace(/\s+$/g,'');
return test;
}
}


/*
// USE: <INPUT onKeyPress="window.status = getkey(event)">
function getkey(e)
{
if (window.event)
return window.event.keyCode;
else if (e)
return e.which;
else
return null;
}

// USE: <INPUT NAME=INT onKeyPress="return goodchars(event,'0123456789')">
function goodchars(e, goods)
{
var key, keychar;
key = getkey(e);
if (key == null) return true;
// get character
keychar = String.fromCharCode(key);
keychar = keychar.toLowerCase();
goods = goods.toLowerCase();
// check goodkeys
if (goods.indexOf(keychar) != -1)
return true;
// control keys
if ( key==null || key==0 || key==8 || key==9 || key==13 || key==27 )
return true;
// else return false
return false;
}
*/

/* Truncates a specified number of decimal places */
function truncate_decimal(original_number, decimals) {
    var result1 = original_number * Math.pow(10, decimals);
    var result2 = Math.floor(result1);
    var result3 = result2 / Math.pow(10, decimals);
    return pad_with_zeros(result3, decimals)
}

/*********************************************************/
/* This script is Copyright (c) Paul McFedries and
Logophilia Limited (http://www.mcfedries.com/).
Permission is granted to use this script as long as
this Copyright notice remains in place.*/


function round_decimals(original_number, decimals) {
    var result1 = original_number * Math.pow(10, decimals);
    var result2 = Math.round(result1);
    var result3 = result2 / Math.pow(10, decimals);
    return pad_with_zeros(result3, decimals)
}

function pad_with_zeros(rounded_value, decimal_places) {

    // Convert the number to a string
    var value_string = rounded_value.toString();

    // Locate the decimal point
    var decimal_location = value_string.indexOf(".");

    // Is there a decimal point?
    if (decimal_location == -1) {

        // If no, then all decimal places will be padded with 0s
        decimal_part_length = 0

        // If decimal_places is greater than zero, tack on a decimal point
        value_string += decimal_places > 0 ? "." : ""
    }
    else {

        // If yes, then only the extra decimal places will be padded with 0s
        decimal_part_length = value_string.length - decimal_location - 1
    }

    // Calculate the number of decimal places that need to be padded with 0s
    var pad_total = decimal_places - decimal_part_length;

    if (pad_total > 0) {

        // Pad the string with 0s
        for (var counter = 1; counter <= pad_total; counter++)
            value_string += "0"
        }
    return value_string
}
/* This script is Copyright (c) Paul McFedries and
Logophilia Limited (http://www.mcfedries.com/).
Permission is granted to use this script as long as
this Copyright notice remains in place.*/
/*********************************************************/


function cleartextbox(objname, str) {
   try {
      var os = getElement(objname);
      if (os.length) {        /* the search pages have more than 1 control with a name of "q", this makes getElement return an array */
         os = os(0);
      }
      var test = trim(os.value.toLowerCase());
      if(test==str.toLowerCase()) {
         os.value = '';
      }
   } catch(err) {
      /*Ignore it*/
   }
}
function filltextbox(objname, str) {
   try {
      var os = getElement(objname);
      if (os.length) {        /* the search pages have more than 1 control with a name of "q", this makes getElement return an array */
         os = os(0);
      }
      var test = trim(os.value.toLowerCase());
      if(test==''||test==str.toLowerCase()) {
         os.value = str;
      }
   } catch(err) {
      /* Ignore it */
   }
}

function hilighttextbox(objname) {
  try {
    var tb = getElement(objname);
    tb.select();
  } catch(err) {
    /* Ignore it */
  }
}

/*
** This is a useful function that will show you all properties of an object
** USE: alert(show_props(obj, 'any name'));
*/
function show_props(obj, obj_name) {
    var result = ""
    for (var i in obj)
        result += obj_name + "." + i + " = " + obj[i] + "\n"
    return result;
}

/****************************************************/
//This code is for the my Account popup menu in the header

var timer = null;
var gobj = null;

function popup(show) {
	var obj = document.getElementById('mouseOverMenu');
	if(show) {
		clearTimeout(timer);
		obj.style.display = 'block';
	} else {
		gobj = obj;
		timer = setTimeout('hideobj(\'mouseOverMenu\')',500);
	}
}

function hideobj(objname) {
	var obj = document.getElementById(objname);
	obj.style.display = 'none';
	clearTimeout(timer);
}

var yft = {
   _shade: {1:'ff', 2:'ee', 3:'dd', 4:'cc', 5:'bb', 6:'aa', 7:'99'},
   fadeIn: function(e,i,basecolor) {
      /* basecolor is the color to reset to after the fade finishes */
      if (i >= 1) {
         var elem = $get(e);
         if (elem) elem.style.backgroundColor = '#ffff' + this._shade[i];
         else return;

         if (i > 1) {
            i -= 1;
            if(basecolor!=null)
               setTimeout("yft.fadeIn('"+elem.id+"',"+i+",'"+basecolor+"')", 200);
            else
               setTimeout("yft.fadeIn('"+elem.id+"',"+i+")", 200);
         } else {
            i -= 1;
            if(basecolor!=null) {
               setTimeout("yft.fadeIn('"+elem.id+"',"+i+",'"+basecolor+"')", 200);
               elem.style.backgroundColor = basecolor;
            } else {
               setTimeout("yft.fadeIn('"+elem.id+"',"+i+")", 200);
               elem.style.backgroundColor = "transparent";
            }
         }
      }
   },
   customFadeIn: function(e,i,colors,delay, initialdelay) {
      if (i >= 0) {
         var elem = $get(e);
         var ca = eval(colors); // Convert to an actual array
         if (elem) elem.style.backgroundColor = ca[i];
         else return;

         if (i > 0) {
            i -= 1;
            if (initialdelay>0) {
              setTimeout("yft.customFadeIn('"+elem.id+"',"+i+",'"+colors+"',"+delay+",0)", initialdelay);
            } else {
              setTimeout("yft.customFadeIn('"+elem.id+"',"+i+",'"+colors+"',"+delay+",0)", delay);
            }
         }
      }
   }
}

/* Used to change the cursor to an hourglass and back again */
function changeCursor(cursor_style) {
   if(cursor_style.toLowerCase() == 'hand' || cursor_style.toLowerCase() == 'pointer') {
      document.body.style.cursor = (isIE) ? 'hand' : 'pointer';   // 'hand' works with IE 5+
   } else {
      document.body.style.cursor = cursor_style;
   }
}

/*
This is a sample routine to attach a focus and blur event to all input boxes on a page
*/

/*
  function fnTXTFocus(varname) {
    var objTXT = document.getElementById(varname)
    objTXT.style.borderColor= "#FFFFCC";
  }

  function fnTXTLostFocus(varname) {
    var objTXT = document.getElementById(varname)
    objTXT.style.borderColor = "#000000";
  }

  function fnOnLoad() {
    var t = document.getElementsByTagName('input');
    var i;
    for(i=0;i<t.length;i++) {
        if(t[i].type == "text") {
            t[i].attachEvent('onfocus', new Function("fnTXTFocus('"+t[i].id+ "')"));
            t[i].attachEvent('onblur', new Function("fnTXTLostFocus('"+t[i].id+ "')"));
        }
    }
  }
*/


/* create Urls given an object with controller and action */
function getUrl(options) {
    var url = '/mvc/' + options.controller + '/' + options.action + '/';
    if (options.id !== undefined) {
        url += (options.id) + '/';
    }

    if (options.qs !== undefined && options.length > 0) {
        url += ('?' + options.qs.join('&').substring(1));
    }

    return url.toLowerCase();
}

function TrackShopByDepartmentClick(departmentName) {
    StullerTrackEvent('Navigation', 'ShopByDepartment', "'" + departmentName + "'");
}

function TrackNavigationClick(linkArea, linkTarget, value) {
    StullerTrackEvent('Navigation', "'" + linkArea + "'", "'" + linkTarget + "'", value);
}

function ProductPageEventTrack(eventName, eventAction) {
    StullerTrackEvent('ProductPage', "'" + eventName + "'", "'" + eventAction + "'");
}

function TrackBuilderPageEvent(action, label) {
    StullerTrackEvent("ProductPage-3C", "'" + action + "'", "'" + label + "'");
}

function TrackMarkupPreviewer(action, label) {
    StullerTrackEvent("MarkupPreviewer", "'" + action + "'", "'" + label + "'");
}

function TrackMeleeFinderEvent(action, label) {
    StullerTrackEvent("MeleeDiamondSearch", "'" + action + "'", "'" + label + "'");
}
function TrackLargeDiamondFinderEvent(action, label) {
    StullerTrackEvent("LargeDiamondSearch", "'" + action + "'", "'" + label + "'");
}

function TrackLabGrownMeleeFinderEvent(action, label) {
    StullerTrackEvent("LabGrownMeleeDiamondSearch", "'" + action + "'", "'" + label + "'");
}
function TrackLabGrownLargeDiamondFinderEvent(action, label) {
    StullerTrackEvent("LabGrownLargeDiamondSearch", "'" + action + "'", "'" + label + "'");
}

function TrackContactInformationEvent(action) {
    StullerTrackEvent("ContactInformation", "'" + action + "'");
}

function TrackPreferenceCenterEvent(action) {
    StullerTrackEvent("PreferenceCenter", "'" + action + "'");
}

function TrackKitBuilderEvent(action, label) {
    StullerTrackEvent("EverAndEverKitBuilder", "'" + action + "'", "'" + label + "'");
}

function TrackMainNavOrLaunchPageNav(isShowcase, isExternal, action, label, thisElement) {
    var isMainNav = $(thisElement).closest("#navigationHeader").length >= 1;
    var isLaunchPageNav = $(thisElement).closest(".nav-launch-page-content").length >= 1;

    if (isMainNav) {
    } else if (isLaunchPageNav) {
        StullerTrackEvent('ContentPage', action, 'Nav-' + label);
    } else {
        StullerTrackEvent('SideNavCMS', action, label);
    }
}

String.prototype.toProperCase = function () {
    if (!('replace' in this))
        return null;
    return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

String.prototype.hasValue = function(checkStringUndefined) {
    return this != null && this != '' && this.replace(/ /g, '') != '' && (!checkStringUndefined || this.replace(/undefined/gi, '') != '');
};

function SetDefaultViewCookie(defaultView) {
    SetCookie('defaultProductView', defaultView, Infinity, '/products');
    $('#setDefaultView').hide();
}
function SetCookie(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/.test(sKey)) { return; }
    var sExpires = "";
    if (vEnd) {
        switch (typeof vEnd) {
            case "number": sExpires = "; max-age=" + vEnd; break;
            case "string": sExpires = "; expires=" + vEnd; break;
            case "object": if (vEnd.hasOwnProperty("toGMTString")) { sExpires = "; expires=" + vEnd.toGMTString(); } break;
        }
    }
    document.cookie = escape(sKey) + "=" + escape(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
}

//Set All Checkboxes to value inside of div
function checkCheckboxesInADiv(divId, checkedValue) {
    //
    var div = $('#' + divId + ' :checkbox');
    if (checkedValue == 'checked' || checkedValue == 'true' || checkedValue == true) {
        $(div).each(function() {
            $(this).attr('checked', 'checked');
        });
    } else {
        $(div).each(function () {
            $(this).removeAttr('checked');
        });
    }

}

function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = escape(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

// add dummy console.log for IE8 & IE9
if (!window.console) window.console = { log: function () { } };

Number.prototype.formatMoney = function (moneySymbol, decimalPlaces, decimalChar, commaChar) {
    var n = this,
        decimalPlaces = isNaN(decimalPlaces = Math.abs(decimalPlaces)) ? 2 : decimalPlaces,
        decimalChar = decimalChar == undefined ? "." : decimalChar,
        commaChar = commaChar == undefined ? "," : commaChar,
        moneySymbol = moneySymbol || "$";
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(decimalPlaces)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return moneySymbol + s + (j ? i.substr(0, j) + commaChar : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + decimalChar) + (decimalPlaces ? decimalChar + Math.abs(n - i).toFixed(decimalPlaces).slice(2) : "");
};

String.prototype.format = function( /*, param[] objects */) {
    var formattedText = this;
    var match;
    while ((match = /{([0-9]+)}/.exec(formattedText)) != null) {
        formattedText = formattedText.replace(match[0], arguments[match[1]]);
    }
    return formattedText;
}

function CollapseLeftNavSection(sectionSelector, collapseExcessSections) {
    if (collapseExcessSections == undefined) {
        collapseExcessSections = false;
    }

    var sectionMenu = collapseExcessSections ? $(sectionSelector).slice(5, $(sectionSelector).length) : $(sectionSelector);
    $(sectionMenu).find(".sectionLabel").addClass("collapsed");
    $(sectionMenu).find(".topFilters").removeClass("in").addClass("collapse").css("height", "0px");;
    var expandIcon = $(sectionMenu).find('.fa');

    var expandIconOld = $(sectionMenu).find('.ui-icon');
    $(expandIconOld).removeClass('ui-icon-minus');
    $(expandIconOld).addClass('ui-icon-plus');
}

function ExpandLeftNavSection(sectionSelector, collapseExcessSections) {
    if (typeof collapseExcessSections == "undefined") {
        collapseExcessSections = false;
    }

    var sectionMenu = collapseExcessSections ? $(sectionSelector).slice(0, 5) : $(sectionSelector);
    $(sectionMenu).find(".sectionLabel").removeClass("collapsed");
    $(sectionMenu).find(".topFilters").removeClass("collapse").addClass("in").css("height", "auto");

    var expandIconOld = $(sectionMenu).find('.ui-icon');
    $(expandIconOld).addClass('ui-icon-minus');
    $(expandIconOld).removeClass('ui-icon-plus');

    if (collapseExcessSections) {
        CollapseLeftNavSection(sectionSelector + ":not('.clicked')", true);
    }
}

function HandleLeftNavCollapse() {
    if ($(window).width() < 751) {
        //collapse all but the sections that have been expanded "on purpose"
        CollapseLeftNavSection("#sideFilterContainer .sideNavSection:not('.clicked')");
    } else {
        //expand all
        ExpandLeftNavSection("#sideFilterContainer .sideNavSection", true);
    }
}


function CollapseLeftNavSection_new(sectionSelector, collapseExcessSections) {
    if (collapseExcessSections == undefined) {
        collapseExcessSections = false;
    }

    var sectionMenu = collapseExcessSections ? $(sectionSelector).slice(5, $(sectionSelector).length) : $(sectionSelector);
    $(sectionMenu).children(".sectionLinks").slideUp("fast");
    var expandIcon = $(sectionMenu).children(".sectionTitle").find('.fa');
    $(expandIcon).removeClass('fa-minus-circle').addClass('fa-plus-circle');
}

function ExpandLeftNavSection_new(sectionSelector, collapseExcessSections) {
    if (collapseExcessSections == undefined) {
        collapseExcessSections = false;
    }

    var sectionMenu = collapseExcessSections ? $(sectionSelector).slice(0, 5) : $(sectionSelector);
    $(sectionMenu).children(".sectionLinks").slideDown("fast");
    var expandIcon = $(sectionMenu).children(".sectionTitle").find('.fa');
    $(expandIcon).addClass('fa-minus-circle').removeClass('fa-plus-circle');

    if (collapseExcessSections) {
        CollapseLeftNavSection_new(sectionSelector + ":not('.clicked')", true);
    }
}

function HandleLeftNavCollapse_new() {
    if ($(window).width() < 751) {
        //collapse all but the sections that have been expanded "on purpose"
        CollapseLeftNavSection_new(".menuSection:not('.clicked')");
    } else {
        //expand all
        ExpandLeftNavSection_new(".menuSection", true);
    }
}


function InitializeTabButton() {
    $(".tabWrapper").each(function () {
        var self = this;
        //	Init first content tab
        var firstOnState = $(self).find('.tabContentOnState').length;
        var init_tabContent = firstOnState ? $(self).find('.tabContentOnState .tabContent').html() : $(self).find(".tabContent").eq(0).html();

        $(self).find('.tabWrapper .mobileContent').eq(0).show();

        $(self).find('.tabWrapper .tabContent').eq(0).html(init_tabContent).fadeIn();
        $(self).find('.tabContent-lg .tabContent').html(init_tabContent).fadeIn();

        // Click event handler for one of the top three action buttons
        $(self).find('.tabButton').on("click", function () {
            var anchor = $(this).find('a').eq(0);
            if ($(this).hasClass("tabButtonOnState")) {
                return false;
            }

            // Remove active state from button
            $(self).find('.tabButton').removeClass('tabButtonOnState');
            // Adds class to new active button
            $(this).addClass('tabButtonOnState');


            //$(self).find('.mobileContent').hide();

            //$(this).parent().find('.mobileContent').show();


            //var tabContentHTML = $(this).parent().find('div.tabContent').html();

            $.when($(self).find('.tabContent-lg .tabContent').fadeOut()).done(function() {
                //$(self).find('.tabContent-lg .tabContent').html(tabContentHTML).fadeIn();
                $(".tabContent").removeClass('tabContentOnState');
                var contentIdToShow = $(anchor).attr('href');
                $(contentIdToShow).addClass('tabContentOnState');
            });
            return false;
        });
    });
}

function InitializeResponsiveCarousel() {
    $(".responsiveCarousel").each(function () {
        var self = $( this );
        if ( self.data( "responsive-carousel-init" ) ) {
            return;
        }
        self.data( "responsive-carousel-init", true );
        var largeItemCount = self.data("large-item-count") || 6;
        var mediumMaxWidth = 1199;
        var mediumItemCount = self.data("medium-item-count") || 4;
        var smallMaxWidth = 991;
        var smallItemCount = self.data("small-item-count") || 3;
        var xsmallMaxWidth = 767;
        var xsmallItemCount = self.data("xs-item-count") || 2;

        var options = {
            rewindNav: self.data("rewind-nav") || false,
            responsiveBaseWidth: $(window),
            items: largeItemCount, // items at large size
            itemsDesktop: [mediumMaxWidth, mediumItemCount], //items at medium size
            itemsDesktopSmall: [smallMaxWidth, smallItemCount], // items at small size
            itemsTablet: [xsmallMaxWidth, xsmallItemCount], // items at x-small
            itemsMobile: false, // itemsMobile disabled - inherit from itemsTablet option
            pagination: self.data("show-pagination") || false,
            navigation: self.data("show-navigation") || false,
            navigationText: ['<span class="fa fa-angle-left" aria-hidden="true"></span>', '<span class="fa fa-angle-right" aria-hidden="true"></span>'],
            scrollPerPage: self.data("scroll-per-page") || true
        };

        self.owlCarousel(options);

        var itemCount = self.find(".owl-item").length;

        if (($(window).width() > mediumMaxWidth && itemCount <= largeItemCount) ||
            ($(window).width() > smallMaxWidth && $(window).width() <= mediumMaxWidth && itemCount <= mediumItemCount) ||
            ($(window).width() > xsmallMaxWidth && $(window).width() <= smallMaxWidth && itemCount <= smallItemCount) ||
            ($(window).width() <= xsmallMaxWidth && itemCount <= xsmallItemCount)
            ) {
            self.siblings(".customNavigation").hide();
        }

        self.siblings(".customNavigation").find(".right.carousel-control").on("click", function () {
            self.trigger("owl.next");
        });
        self.siblings(".customNavigation").find(".left.carousel-control").on("click", function () {
            self.trigger("owl.prev");
        });
    });
}

$(function () {
    $(".sectionLabel").click(function () {
        var sectionMenu = $(this).siblings(".topFilters");

        if (sectionMenu.is(":visible")) {
            $(this).closest(".sideNavSection").removeClass("clicked");
        } else {
            $(this).closest(".sideNavSection").addClass("clicked");
        }
    });
});

function SubmitPageRating() {
    if ($("#starRating").val() == "") {
        $("#pageRatingError").show();
        $("#ratingError").show();
    } else {
        $.ajax({
            url: '/pagerater/submitpagerating',
            type: 'POST',
            data: { rating: $("#starRating").val(), comments: $("#Comments").val(), page: $("#Page").val(), callerfullpath: $("#CallerFullPath").val() },
            success: function(data) {
                if (data) {
                    $("#pageRatingForm").hide();
                    $("#pageRatingSuccess").show();

                    $(".modal-footer").hide();
                }
            }
        });
    }
}

$.loadImage = function (url) {
    if (!url)
        return url;
    return $.Deferred(function(def) {
        var img = new Image();
        img.onload = function() {
            def.resolve(url);
        };
        img.onerror = function() { def.reject(url); };
        def.then(function () { img.onload = img.onerror = null; });
        img.src = url;
    }).promise();
};

$.ajaxModal = function(settings) {
    var defaults = {
        url: null,
        data: null,
        modalCss: null,
        modalDialogCss: null,
        type: "POST",
        modalTitle:
            "<button type='button' class='close' data-dismiss='modal' aria-label='Close' style='position: absolute;right: 8px;top: 8px;z-index: 10 !important;height: 25px;width: 25px;'><span aria-hidden='true'>&times;</span></button>"
    };

    settings = $.extend({}, defaults, settings);

    settings.modalCss = settings.modalCss || "";
    settings.modalCss += " modal fade";
    settings.modalDialogCss = settings.modalDialogCss || "";
    settings.modalDialogCss += " modal-dialog";
    settings.modalTitle = settings.modalTitle || "";
    if (settings.modalTitle != defaults.modalTitle)
        settings.modalTitle = '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
            '<h3 class="text-center topMarginLarge">' +
            settings.modalTitle +
            '</h3>' +
            '</div>';
    var dialogHtml =
        "<div class='" +
            settings.modalCss +
            "' tabindex='-1' role='dialog' aria-hidden='true'>" +
            "<div class='" +
            settings.modalDialogCss +
            "'>" +
            "<div class='modal-content'>" +
            settings.modalTitle +
            "<div class='modal-body' style='min-height:150px;'></div>" +
            "</div>" +
            "</div>" +
            "</div>";
    var dialog = $(dialogHtml);
    var $dialogBody = dialog.find(".modal-body");

    var loadingIndicatorHtml =
        '<img alt="Loading..." src="//assets.stullercloud.com/web/static/i/ajaxloaders/small-ajax-loader.gif" style="position:absolute;top:50%;left:50%;margin:-30px 0 0 -30px;">';

    $("body").append(dialog);

    $dialogBody.html(loadingIndicatorHtml);
    $(dialog).modal();
    var ajaxFunc = $.ajax({
        type: settings.type,
        url: settings.url,
        data: settings.data,
        contentType: "application/json; charset=utf-8",
        dataType: "html",
        error: function(req, msg, err) {
            $dialogBody.html(msg);
        },
        success: function(msg) {
            $dialogBody.html(msg);
            InitializeGenericQTip();
        }
    });

    $(dialog).on('hidden.bs.modal',
        function(e) {
            if (ajaxFunc != null) {
                ajaxFunc.abort();
            }
            $(dialog).remove();
        });
    return ajaxFunc;
};

function createGuid()
{
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function(c) {
            var r =  (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    return uuid;
}

function htmlEncode(txt) {
    return document.createElement('a').appendChild(document.createTextNode(txt)).parentNode.innerHTML;
}


$.cachePromise = function () {
    var cache = {};
    return function (key, getPromiseObject) {
        if (!cache[key]) {
            cache[key] = getPromiseObject();
    }
        return cache[key];
    }
}();

function isNullOrEmpty( s ){
    return s == null || s.trim().length == 0;
}

function buildNumericHotkeyValue(zeroBasedIndex) {
    if (typeof zeroBasedIndex == "undefined" || zeroBasedIndex == null)
        return "";

    var normalIndex = zeroBasedIndex + 1;
    if (normalIndex > 19)
        return "";

    if (normalIndex > 9) {
        return "Shift + " + (normalIndex - 9).toString();
    }
    return normalIndex.toString();
}

function handleNumericEntry(event) {
    if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
        // Allow: Ctrl+A
        (event.keyCode == 65 && event.ctrlKey === true) ||
        // Allow: Ctrl+V
        (event.keyCode == 86 && event.ctrlKey === true) ||
        // Allow: . ,
        (event.keyCode == 188 || event.keyCode == 190 || event.keyCode == 110) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 40) ||
        // Allow: F1 through F12
        (event.keyCode >= 112 && event.keyCode <= 123)) {
        // let it happen, don't do anything
        return;
    }
    else {
        // Ensure that it is a number and stop the keypress
        if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
            event.preventDefault();
        }
    }
}

function dateFormatIsValid(str) {
    var t = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (t === null)
        return false;
    var d = +t[2], m = +t[1], y = +t[3];
    if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        return true;
    }
    return false;
}

function repeatString(string, times) {
	if (times < 0)
		return '';
	if (times === 1)
		return string;
	else
		return string + repeatString(string, times - 1);
}

function pad(number, size) {
	var s = String(number);
	while (s.length < (size || 2)) { s = "0" + s; }
	return s;
}

function getUrlParameter(query, name) {
	name = name && name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(query);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getStoneShapeSVGPartial(containerId) {
    $.ajax({
        type: "GET",
        url: "/cms/public/StoneShapeIconsSVG",
        data: "",
        contentType: "application/json; charset=utf-8",
        dataType: "html",
        error: function (req, msg, err) { ShowError(req, msg, err); },
        success: function (result) {
            $(containerId).html(result);
        }
    });
}

function is_touch_device() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function(query) {
        return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}

function triggerCartUpdatedEvent() {
    createAndDispatchEvent("cart-updated");
}

function getBrowserAndVersion() {

    var navUserAgent = navigator.userAgent;
    var browserName = navigator.appName;
    var browserVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var tempNameOffset, tempVersionOffset, tempVersion;


    if ((tempVersionOffset = navUserAgent.indexOf("Opera")) != -1) {
        browserName = "Opera";
        browserVersion = navUserAgent.substring(tempVersionOffset + 6);
        if ((tempVersionOffset = navUserAgent.indexOf("Version")) != -1)
            browserVersion = navUserAgent.substring(tempVersionOffset + 8);
    } else if ((tempVersionOffset = navUserAgent.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        browserVersion = navUserAgent.substring(tempVersionOffset + 5);
    } else if ((tempVersionOffset = navUserAgent.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        browserVersion = navUserAgent.substring(tempVersionOffset + 7);
    } else if ((tempVersionOffset = navUserAgent.indexOf("Safari")) != -1) {
        browserName = "Safari";
        browserVersion = navUserAgent.substring(tempVersionOffset + 7);
        if ((tempVersionOffset = navUserAgent.indexOf("Version")) != -1)
            browserVersion = navUserAgent.substring(tempVersionOffset + 8);
    } else if ((tempVersionOffset = navUserAgent.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        browserVersion = navUserAgent.substring(tempVersionOffset + 8);
    } else if ((tempNameOffset = navUserAgent.lastIndexOf(' ') + 1) < (tempVersionOffset = navUserAgent.lastIndexOf('/'))) {
        browserName = navUserAgent.substring(tempNameOffset, tempVersionOffset);
        browserVersion = navUserAgent.substring(tempVersionOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }

    // trim version
    if ((tempVersion = browserVersion.indexOf(";")) != -1)
        browserVersion = browserVersion.substring(0, tempVersion);
    if ((tempVersion = browserVersion.indexOf(" ")) != -1)
        browserVersion = browserVersion.substring(0, tempVersion);

    return {
        browserName: browserName,
        browserVersion: parseFloat(browserVersion)
    }
}

/**
 * Opens live chat (replaces legacy `openChat` function)
 */
function openChatHandler () {
    const liveChatButton = document.getElementById('embeddedMessagingConversationButton');

    if (liveChatButton) {
        liveChatButton.click();
    } else {
        $("#live-chat-disabled-modal").modal('show');
    }
}

/**
 * Stuller event listener to open live chat
 */
addStullerEventListener('live-chat-open', openChatHandler);

function createAndDispatchEvent(eventName, eventTarget, eventData) {
    var event;
    eventTarget = eventTarget || window;
    if (typeof (CustomEvent) === 'function') {
        event = new CustomEvent(eventName, { detail: eventData });
    } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, eventData || {});
    }

    eventTarget.dispatchEvent(event);
}

Date.prototype.stdTimezoneOffset = function () {
    var jan = new Date(this.getFullYear(), 0, 1);
    var jul = new Date(this.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
}

Date.prototype.isDstObserved = function () {
    return this.getTimezoneOffset() < this.stdTimezoneOffset();
}

function isElementInViewport(el) {
    // Check if element if jQuery element
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}
